<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
    <OrderListHeader />
    <v-divider style="margin-bottom: 5px;margin-top: 5px;"></v-divider>
    <div style="margin-bottom:1px">


      <!-- <el-input size="mini" class="search" placeholder="请输入搜索内容" v-model="search" clearable></el-input> -->
      <el-select
          v-model="search"
          class="search"
          size="mini"
          filterable
          remote
          clearable
          reserve-keyword
          placeholder="可搜索房产/客户姓名"
          :remote-method="remoteMethod"
          @change="changes"
          :loading="loading">
          <el-option
            v-for="item in selectList"
            :key="item.id"
            :label="item.house"
            :value="item.house">
          </el-option>
        </el-select>

      <el-select size="mini" v-model="chargeitemID" filterable placeholder="费用类型" class="kuan">
        <el-option
          key=""
          label="全部费用"
          value="">
        </el-option>
        <el-option
          v-for="item in chargeitem"
          :key="item.id"
          :label="item.chargeItem_name"
          :value="item.id">
        </el-option>
      </el-select>

      <el-date-picker size="mini"
                      v-model="datevalue"
                      type="daterange"
                      unlink-panels
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
      </el-date-picker>

      <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
<!--      <el-button size="mini" type="primary text2" @click="xiugai" v-if="checked.checked0 || checked.checked1 || checked.checked2 || checked.checked3 || checked.checked4 || checked.checked5 || checked.checked6 || checked.checked7 || checked.checked8 || checked.checked9 || checked.checked10 || checked.checked11 " >核销</el-button>-->
      <!-- <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="excelPost">导出</el-button> -->
    </div>
    <div style="text-align: right">
      <el-button size="mini" type="primary text2" @click="bindGroupBy(1)">明细</el-button>
      <el-button size="mini" type="primary text2" @click="bindGroupBy(2)">收费周期</el-button>

<!--      <el-radio v-model="group_by" @click="bindGroupBy(1)" label="1">明细</el-radio>-->
<!--      <el-radio v-model="group_by" @click="bindGroupBy(2)" label="2">收费周期</el-radio>-->
    </div>

    <div style="display: flex;color: red;">
      <div>总金额：￥{{money}}元</div>
    </div>
    <v-divider></v-divider>
    <v-simple-table :height="__TABLE_HEIGHT__">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">选择</th>
              <th class="text-left" v-if="group_by===1">房产</th>
              <th class="text-left">收费项</th>
              <th class="text-left">单价</th>
              <th class="text-left">用量面积</th>
              <th class="text-left">计费周期</th>
              <th class="text-left">应收日期</th>
              <th class="text-left">本期应收</th>
              <th class="text-left">本期欠费</th>
              <th class="text-left">减免金额</th>
              <th class="text-left">违约金</th>
              <th class="text-left">减免违约金</th>
              <th class="text-left">操作</th>
            </tr>
          </thead>
          <!-- 撤销 -->
          <tbody
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)">
            <tr class="text1" v-for="(item,index) in desserts" :key="index">
              <td>
                <div style="display: flex;">
                  <div v-if="item.state==1 && ERP.isPermission(4003007006)">
                    <el-checkbox v-if="index==0" v-model="checked.checked0" :true-label='item.ids'></el-checkbox>
                    <el-checkbox v-if="index==1" v-model="checked.checked1" :true-label='item.ids'></el-checkbox>
                    <el-checkbox v-if="index==2" v-model="checked.checked2" :true-label='item.ids'></el-checkbox>
                    <el-checkbox v-if="index==3" v-model="checked.checked3" :true-label='item.ids'></el-checkbox>
                    <el-checkbox v-if="index==4" v-model="checked.checked4" :true-label='item.ids'></el-checkbox>
                    <el-checkbox v-if="index==5" v-model="checked.checked5" :true-label='item.ids'></el-checkbox>
                    <el-checkbox v-if="index==6" v-model="checked.checked6" :true-label='item.ids'></el-checkbox>
                    <el-checkbox v-if="index==7" v-model="checked.checked7" :true-label='item.ids'></el-checkbox>
                    <el-checkbox v-if="index==8" v-model="checked.checked8" :true-label='item.ids'></el-checkbox>
                    <el-checkbox v-if="index==9" v-model="checked.checked9" :true-label='item.ids'></el-checkbox>
                    <el-checkbox v-if="index==10" v-model="checked.checked10" :true-label='item.ids'></el-checkbox>
                    <el-checkbox v-if="index==11" v-model="checked.checked11" :true-label='item.ids'></el-checkbox>
                  </div>
                  <div v-else>
                    <el-checkbox disabled></el-checkbox>
                  </div>
                  <!--            <div style="margin-left: 5px;">{{item.id}}</div>-->
                </div>
              </td>
              <td v-if="group_by===1">{{item.h_name_date}}</td>
              <td style="text-align: left;">{{item.charge_name}}</td>
              <td>{{item.xsc_Price}}</td>
              <td >{{item.xsc_Amount}}</td>
              <td >
                  {{item.min_date}} 至 {{item.max_date}}
              </td>
              <td>{{item.max_ymt}}</td>
              <td>{{item.receivable_in_the_current_period}}</td>
              <td>{{item.default_in_this_period}}</td>
              <td>{{item.discount}}</td>
              <td>{{item.delaySum}}</td>
              <td>{{item.delayDiscount}}</td>
              <td class="cdj_td">
                <div style="cursor:pointer;" v-if="ERP.isPermission(4003001004)&& group_by===2">
                  <div @click="chakan(item)">详情</div>
                </div>
                <div style="cursor:pointer;" v-if="ERP.isPermission(4003001004)&& group_by===1">
                  <div @click="chakan2(item)">详情</div>
                </div>

                <div style="cursor:pointer;" v-if="item.state==1 && ERP.isPermission(4003007005)&& group_by===1">
                  <div style="color: #1867c0;margin-left: 5px;" @click="reduction(item)">减免</div>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <div class="pages" v-if="desserts">
        <Page :total="total" :page-size="page" @on-change="change"  show-total />
      </div>
      <div class="zhanwu" v-else>没有数据</div>

     <Modal
       v-model="modal12"
        ok-text="确定"
        width="500"
        title="查看详情">
        <div v-if="chakana['id']">
           <p>ID：{{chakana['id']}}</p>
           <p>房产ID：{{chakana['house_id']}}</p>
           <p>生成组ID：{{chakana['weiyi']}}</p>
           <p>编号：{{chakana['number']}}</p>
           <p>姓名：{{chakana['h_name']}}</p>
           <p>组织id：{{chakana['company_id']}}</p>
           <p>项目：{{chakana.h_name_date}}</p>
           <p>收费项：<span v-if="chakana.charge_name">{{chakana.charge_name}}</span><span v-else>{{chakana.xsc_ChargeName}}</span></p>
           <p>实收金额：{{chakana['charge']}}</p>
           <p>应收金额：{{chakana['chargePay']}}</p>
           <p>减免金额：{{chakana['discount']}}</p>
           <p>滞纳金额：{{chakana['delaySum']}}</p>
           <p>滞纳天数：{{chakana['delayDays']}}</p>
           <p>减免滞纳金额：{{chakana['delayDiscount']}}</p>
           <p>已缴金额：{{chakana['PaidChargeSum']}}</p>
           <p>状态：<span v-if="chakana.state==1">待支付</span><span v-if="chakana.state==2">已完成</span></p>
           <p v-if="chakana.remark != ''">备注：{{chakana['remark']}}</p>
           <p>生成时间：{{chakana['generate_date']}}</p>
           <p v-if="chakana.ymt1=='' && chakana.explain==''">仪表编号：{{chakana['ybiao']}}</p>
           <p v-if="chakana.ymt1=='' && chakana.explain==''">抄表读数：{{chakana['chaobiaodushu']}}</p>
           <p v-if="chakana.ymt1==''">抄表人或负责人：{{chakana['chaobiaoname']}}</p>
           <p v-if="chakana.explain != ''">收费说明：{{chakana['explain']}}</p>
           <p>计费开始：{{chakana.startDate}}</p>
           <p><span >计费结束：{{chakana.endDate}}</span></p>
           <p v-if="chakana['log_name']!=null">后台付款操作人：{{chakana['log_name']}}</p>
        </div>
     </Modal>
     <!-- 减免 -->
     <Modal
        v-model="reductions"
        ok-text="确定"
        width="500"
        @on-ok="cdj_reduction"
        title="减免(折扣)">
        <div>
          <div>收费金额：{{order.charge}}</div>
          <div>应收金额：{{order.chargePay}}</div>
          <div>已缴金额：{{order.PaidChargeSum}}</div>
          <div>滞纳天数：{{order.delayDays}}</div>
          <div>滞纳金额：{{order.delaySum}}</div>
          <div>减免金额：{{order.discount}}</div>
          <div>减免滞纳金额：{{order.delayDiscount}}</div>
          <RadioGroup v-model="buttonSize" type="button" style="margin-top:10px">
              <Radio label="1">按金额减免</Radio>
              <Radio label="2">按百分比减免</Radio>
          </RadioGroup>
          <div style="margin-top: 10px;">减免金额公式：原总金额 - 减免金额 = 需支付金额</div>
          <div>减免滞纳金公式：原滞纳金总金额 - 减免金额 = 需支付金额</div>
          <br>
          <div>
            减 免 金 额：{{priceCharge}} -
            <input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="charge">
            = {{price}}
            <span v-if="buttonSize == 2" style="margin-left: 20px;"><input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="chargePercentage">%</span>
          </div>
          <div style="margin-top: 3px;">
            减免滞纳金：{{Number(order.delaySum)}} -
            <input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="charges">
            = {{prices}}
            <span v-if="buttonSize == 2" style="margin-left: 20px;"><input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="chargePercentage1">%</span>
          </div>
        </div>
     </Modal>

    <Modal
      v-model="modal13"
      :footer-hide="true"
      width="90%"
      :mask="true"
      title="查看详情">
      <OrderList3 ref="OrderList3" v-if="modal13"></OrderList3>
    </Modal>
    </div>
</div>

</template>

<script>
import OrderList3 from "./List3";
import OrderListHeader from "../Common/OrderListHeader";
export default {
  name: 'NotPayList',
  data () {
    return {
      chargeitemID:'',
      chargeitem:[],
      chargePercentage:'',
      chargePercentage1:'',
      buttonSize:'1',
      checked:{
        checked0:'',
        checked1:'',
        checked2:'',
        checked3:'',
        checked4:'',
        checked5:'',
        checked6:'',
        checked7:'',
        checked8:'',
        checked9:'',
        checked10:'',
        checked11:'',
      },
      money:'--',
      modal12:false,
      loading:false,
      reductions:false,
      datevalue:[],
       options: [
        {
          value: '',
          label: ''
        },],
       options1: [
        {
          id: 1,
          label: '编号'
        },
        {
          id: 2,
          label: '姓名'
        },
        {
          id: 3,
          label: '身份证'
        },
        {
          id: 4,
          label: '房产'
        },
        ],
      value: '',
      value1:'',
      value2:1,
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      chakana:[],
      state:2,
      order:{
        charge:0,
        chargePay:0,
        PaidChargeSum:0,
        discount:0,
        delaySum:0,
        delayDays:0,
        delayDiscount:0,
      },
      charge:0,
      price:0,
      charges:0,
      prices:0,
      priceCharge:0,
      itemOrder:[],
      homeName:'',
      modal13:false,
      group_by:2,
      selectList:[],
      project_id:''
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    ERP.showLoading()
    this.$Loading.start();
    this.$myhttp.get('admin/getorderList?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.value = backdata.data;
      this.$Loading.finish();
      ERP.hideLoading()
        this.moneys();
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
    });
    //加载收费大类（费项）
    this.$myhttp.get('admin/common/getChargeitem',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //搜索框选中房产
    changes(e){
      this.change(1);
    },
    //导出
    excelPost(){
      if(this.state != 1){
        this.$Message.error('点击待付款，选择费用类型导出');
        return false;
      }
      if(this.chargeitemID == ''){
        this.$Message.error('费用类型不能为空');
        return false;
      }
      this.$Loading.start();
      this.$myhttp.get('admin/getOrderExcel?id=1&search='+ this.search +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          console.log(333);
          this.$Loading.finish();
      });
    },
    //查询总欠费
    moneys(){
      this.$myhttp.get('admin/getMoney2?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID+"&homeName="+this.homeName+'&tm_limit='+this.datevalue.join(','),{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.money = backdata.data['money'];
      });
    },
    //减免（折扣）
    cdj_reduction(){
      var order = this.order;
      //收费金额
      var charge = this.price;
      //减免收费金额
      var discount = this.charge;
      //滞纳金额
      var delaySum = this.prices;
      //减免滞纳金额
      var delayDiscount = this.charges;
      var data = {
        id:order.id,
        charge:charge,
        discount:discount,
        delaySum:delaySum,
        delayDiscount:delayDiscount
      };
      var delaySum1 = Number(delaySum)+Number(delayDiscount);
      var charge1 = Number(charge)+Number(discount);
      if(delaySum1.toFixed(2) < Number(delayDiscount) || charge1.toFixed(2) < Number(discount)){
        this.$Message.error('金额不合法');
        return false;
      }
      this.$myhttp.post('admin/orderDiscount',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.searchs();
          this.$Message.success('操作成功!');
      });
      // console.log(data);
    },
    //弹窗查看
    chakan(item){
      console.log(item);
      // this.chakana = e;
      // this.modal12 = true;
      var that=this;
      that.modal13=true;
      setTimeout(function (){
        that.$refs.OrderList3.setOptData({
          roomName:item.h_name_date,
          year:item.Y,
          yearMoney:item.year_money,
          chargeId:item.charge_item_id,
          state:that.state
        })
      },200);

    },
    chakan2(e){
      console.log(e);
      this.chakana = e;
      this.modal12 = true;
    },
    //减免
    reduction(item){
      this.itemOrder = item;
      if(this.reductions == false){
        this.buttonSize = "1";
        this.reductions = true;
      }
      this.order = item;
      var delaySum = Number(this.order.delaySum)-Number(this.order.delayDiscount);
      var priceCharge = Number(this.order.charge) + Number(this.order.discount) - delaySum;
      this.priceCharge = priceCharge.toFixed(2);//原总金额
      this.charge = Number(item.discount);
      var priceCharges = Number(this.order.charge) + Number(this.order.discount) - Number(this.order.delaySum) - Number(this.order.discount) + Number(this.order.delayDiscount);
      this.price = priceCharges.toFixed(2);//收费金额
      this.charges = Number(item.delayDiscount);
      var prices = Number(item.delaySum) - Number(item.delayDiscount);
      this.prices = prices.toFixed(2);
    },
    //确定付款(核销)
    xiugai(){
      this.$confirm('确定核销吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading=true;
          this.$myhttp.post('admin/listXiuGai',{checked:this.checked},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data.code == 201){
                this.$Message.error(backdata.data.message);
              }
              if(backdata.data == 200){
                this.checked={
                  checked0:'',
                  checked1:'',
                  checked2:'',
                  checked3:'',
                  checked4:'',
                  checked5:'',
                  checked6:'',
                  checked7:'',
                  checked8:'',
                  checked9:'',
                  checked10:'',
                  checked11:'',
                };
                this.change(1)
                this.loading=false;
                this.$Message.success('操作成功!');
              }
          });
        }).catch(() => {

        });
    },
    modals(e){
      if(this.state != e){
        this.state = e;
        this.money = "--";
        this.change(1);
        this.moneys();
      }
    },
    //远程搜索
    remoteMethod(query){
      if (query !== '') {
        // console.log(query);
        this.loading = true;
        this.$myhttp.get('admin/common/house_text?text='+query+'&project_id='+this.project_id,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
        });
      } else {
        this.selectList = [];
      }
    },
    //获得当前多少页,分页
    change(e){
      var that=this;
      if(!this.search){
        this.$alert("请选择房产!");
        return false;
      }
      ERP.showLoading()
      this.$Loading.start();
      this.$myhttp.getRequest({
        url:"admin/orderList4",
        data:{
          id:e,
          search:this.search,
          company:this.value,
          company1:this.value2,
          state:this.state,
          chargeitemID:this.chargeitemID,
          homeName:this.homeName,
          tm_limit:this.datevalue.join(','),
          group_by:this.group_by
        }
      },data=>{ // 异步执行成功后
        //console.log(data[0])
        this.desserts = data[0];
        this.total = data[1];
        this.page = data[2];
        this.$Loading.finish();
        ERP.hideLoading()
      },err=>{
        this.$Loading.finish();
        ERP.hideLoading()
        that.$alert("请求异常！")
      })
    },
    //搜索
    searchs(){
      this.money = "--";
      this.change(1);
      this.moneys();
    },
    //删除
    del(e){
      this.$confirm('此操作将永久删除该权限吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading=true;
          this.$myhttp.post('admin/listDelete',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                this.dela = true;
                this.money = "--";
                this.change(1);
                this.$Message.success('删除成功!');
                this.moneys();
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      //console.log(this.project_id );
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      // this.homeName=tree_str;
      // this.change(1);
      this.value2=4;
      this.search=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.change(1);
        this.moneys();
      }
    },
    bindGroupBy(group_by){
      this.group_by=group_by;
      this.change(1)
    }
  },
  watch:{
      charge(){
        var price = Number(this.order.charge) + Number(this.order.discount) - Number(this.order.delaySum) - Number(this.charge) + Number(this.order.delayDiscount);
        this.price = price.toFixed(2);
        if(this.price < 0){
          this.$Message.error('减免金额不合法');
          return false;
        }
      },
      charges(){
        var prices = Number(this.order.delaySum) - Number(this.charges);
        this.prices = prices.toFixed(2);
        if(this.prices < 0){
          this.$Message.error('减免滞纳金额不合法');
          return false;
        }
      },
      //减免是按金额减免还是按百分比减免切换
      buttonSize(){
        this.chargePercentage = '';
        this.chargePercentage1 = '';
        this.reduction(this.itemOrder);
      },
      //减免金额百分比
      chargePercentage(){
        this.charge = Number(this.priceCharge)*(Number(this.chargePercentage)/100);
        this.charge = this.charge.toFixed(2);
      },
      //减免滞纳金百分比
      chargePercentage1(){
        this.charges = Number(this.order.delaySum)*(Number(this.chargePercentage1)/100);
        this.charges = this.charges.toFixed(2);
      },
  },

  components: {
    OrderListHeader,
    OrderList3,
    "erp-tree": () => import('../Common/erp-tree.vue')
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/NotPayList.vue